import _asyncToGenerator from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es7.array.includes.js";
import { Integrations } from '@sentry/tracing';
import * as Sentry from '@sentry/vue';
import { version } from "../../package.json";
import store from "../store";

// Since multiple errors shows multiple Report Dialogs this is used to prevent that...
var dialogIsOpen = false;

// Throw exception when app is not in maintenance mode
var checkMaintenanceMode = function checkMaintenanceMode() {
  return store.getters['common/check'] === 'yes';
};
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Vue, router;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          Vue = _ref.Vue, router = _ref.router;
          if (process.env.SENTRY_DSN) {
            Sentry.init({
              Vue: Vue,
              dsn: process.env.SENTRY_DSN,
              release: "".concat(process.env.APP_ENV, "-").concat(version),
              autoSessionTracking: false,
              beforeSend: function beforeSend(event, hint) {
                // Prevent reporting 419 and 422 error
                var response = hint.originalException.response;
                if (response && [419, 422].includes(response.status)) {
                  return null;
                }

                // Check if it is an exception, and if so, show the report dialog
                if (event.exception && dialogIsOpen === false && !document.querySelector('.sentry-error-embed-wrapper') && !checkMaintenanceMode()) {
                  dialogIsOpen = true;
                  Sentry.showReportDialog({
                    eventId: event.event_id
                  });
                }
                setTimeout(function () {
                  dialogIsOpen = false;
                }, 1000);
                return !checkMaintenanceMode() && event;
              },
              environment: process.env.APP_ENV,
              integrations: [new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: ['localhost', /^\//]
              })],
              //   whitelistUrls: [
              //     process.env.API_URL + '/auth'
              //   ],
              ignoreErrors: ['ResizeObserver loop limit exceeded', 'ResizeObserver loop completed with undelivered notifications.'
              //     // Random plugins/extensions
              //     'top.GLOBALS'
              //     // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
              //     // 'originalCreateNotification',
              //     // 'canvas.contentDocument',
              //     // 'MyApp_RemoveAllHighlights',
              //     // 'http://tt.epicplay.com',
              //     // 'Can\'t find variable: ZiteReader',
              //     // 'jigsaw is not defined',
              //     // 'ComboSearch is not defined',
              //     // 'http://loading.retry.widdit.com/',
              //     // 'atomicFindClose',
              //     // // Facebook borked
              //     // 'fb_xd_fragment',
              //     // // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
              //     // // reduce this. (thanks @acdha)
              //     // // See http://stackoverflow.com/questions/4113268
              //     // 'bmi_SafeAddOnload',
              //     // 'EBCallBackMessageReceived',
              //     // // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
              //     // 'conduitPage'
              ],

              // Set tracesSampleRate to 1.0 to capture 100%
              // of transactions for performance monitoring.
              // We recommend adjusting this value in production
              tracesSampleRate: 1.0
            });
          }
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();